import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';

export const PlayIcon = PlayCircleOutlineRoundedIcon;
